



























import Vue from 'vue'
import settings from "@/settings.coffee"

export default {
  name: 'FileUpload'
  props:
    model: null
    objectId: null
    maxFiles: null
  data: ()->
    return {
      files: [],
      newFiles: []
    }
  computed:
    allFiles: ()->
      ret = []
      if @files
        for f in @files
          ret.push(f)
      for f in @newFiles
        ret.push(f)
      return ret        
  methods:
    fileUrl: (index)->
      console.log("settings.backend_url", settings.backend_url)
      if @files? and @files[index]?
          settings.backend_url+@files[index].url
    deleteFile: (index)->
      file = @allFiles[index]
      if file.existInDb
        formData = new FormData()      
        formData.append('model', @model)
        formData.append('objectId', @objectId)
        formData.append('name', file.name)
        ret = await Vue.http.post(settings.file_delete_url, formData)
        @get_files()
      else
        newIndex = @newFiles.indexOf(file)
        @newFiles.splice(newIndex, 1);
    save: ()->
      formData = new FormData()
      formData.append('model', @model)
      formData.append('objectId', @objectId)
      i = 0
      console.log("this.$refs", this.$refs, this.$refs.file_upload.files, @objectId, "#")
      for file in this.$refs.file_upload.files
          formData.append("file_"+i, this.$refs.file_upload.files[0]);
          i++
      if @objectId
        #-- save right now
        await Vue.http.post(settings.file_upload_url, formData)
        @get_files()
      else
        #-- wait for the main object to be saved
        for file in this.$refs.file_upload.files
            @newFiles.push(file)
      return
    save_from_parent: (uid)->
      console.log("save_from_parent")
      formData = new FormData()
      formData.append('model', @model)
      formData.append('objectId', uid)
      i = 0
      console.log("this.$refs", this.$refs, this.$refs.file_upload.files, uid, "#")
      for file in this.newFiles
          #reader = new FileReader();
          #console.log(file)
          #reader.addEventListener('load', (event)->
          #    console.log("event", event.target)

          #);
          #reader.readAsArrayBuffer(file);
          formData.append("file_"+i, file);
          i++

      await Vue.http.post(settings.file_upload_url, formData)
      @get_files()      
      return
    clearTmpFiles: ()->
      @newFiles = []  
    get_files: ()->
      if @objectId? and @objectId != ''
          formData = new FormData()
          formData.append('model', @model)
          formData.append('objectId', @objectId)
          ret = await Vue.http.post(settings.file_list_url, formData)
          console.log(ret)
          @files = ret.body.result.map (el)->
            el.existInDb = true
            return el
      else
        @files = []
               
  mounted: ()->
    console.log("file_upload mounted")
    @get_files()
    return
  watch:
    objectId: ()->
      console.log("objectId", @objectId)
      @get_files()
}
